import React from 'react';
import SmartLink from '../../common/smart-link';

interface IQuickLinkItemElementProps {
    title: string;
    subTitle?: string;
    imageUrl?: string;
    imageAltText?: string;
    callToActionUrl: string;
    isImpressions?: boolean;
}

const QuickLinkItemElement = ({
    title,
    subTitle,
    imageUrl,
    imageAltText,
    callToActionUrl,
    isImpressions,
}: IQuickLinkItemElementProps) => {
    return (
        <div
            className={
                isImpressions ? 'quick-link-item impression' : 'quick-link-item'
            }
            style={imageUrl ? { height: '210px' } : { minHeight: '100px' }}
        >
            <SmartLink to={callToActionUrl}>
                <div
                    className="overlay"
                    style={{ paddingTop: imageUrl ? '' : '33px' }}
                >
                    {imageUrl && (
                        <div>
                            <img src={imageUrl} alt={imageAltText} />
                        </div>
                    )}
                    <div className="row">
                        <div
                            className="col-md-12"
                            style={{ textAlign: 'center' }}
                        >
                            <h4>{title}</h4>
                        </div>
                    </div>
                    {subTitle && (
                        <div className="row">
                            <div className="col-md-12">
                                <h5>{subTitle}</h5>
                            </div>
                        </div>
                    )}
                </div>
            </SmartLink>
        </div>
    );
};

export default QuickLinkItemElement;
